/* --------------------------------------------------------------------------
   Laddar diagrammen i React (dist/charts.js) första gången de behövs

   Filen hämtas från samma server som sidan, som ett vanligt skript, så
   säkerhetspolicyn (script-src 'self') gäller oförändrad. Går den inte att
   ladda visas en förklaring i diagrammets ruta; tabellen under har samma
   siffror.
   -------------------------------------------------------------------------- */

let laddning = null;

/** Ger window.ecCharts när charts.js är inläst. Laddar filen en gång. */
export function loadCharts(){
  if(!laddning){
    laddning = new Promise((resolve, reject) => {
      if(window.ecCharts){ resolve(window.ecCharts); return; }
      const s = document.createElement('script');
      s.src = 'charts.js';
      s.onload = () => window.ecCharts ? resolve(window.ecCharts) : reject(new Error('charts.js saknar diagrammen'));
      s.onerror = () => { laddning = null; reject(new Error('charts.js kunde inte laddas')); };
      document.head.appendChild(s);
    });
  }
  return laddning;
}

/** Senaste anropets nummer per diagramruta */
const senaste = new WeakMap();

/**
 * Anropar fn(ecCharts) när diagrammen är inlästa. Bara det senaste anropet
 * för samma ruta körs: ändrar kunden urvalet medan filen laddas ritas det
 * sista urvalet, inte varje mellanläge.
 */
export function withCharts(box, fn){
  const nr = (senaste.get(box) || 0) + 1;
  senaste.set(box, nr);
  loadCharts().then(c => { if(senaste.get(box) === nr) fn(c); }).catch(() => {
    if(senaste.get(box) !== nr) return;
    box.textContent = 'Diagrammet kunde inte laddas. Ladda om sidan. Tabellen nedan har samma siffror.';
    box.classList.add('chart-failed');
  });
}
